module.exports = __webpack_public_path__ + "static/img/duom07.f911208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom07.png
// module id = 983
// module chunks = 0